export default "__VITE_ASSET__40470c3e__"